import { useState, useMemo } from 'react'
import useResizeObserver from 'use-resize-observer'
import { debounce } from 'lodash'

export const useDebouncedResizeObserver = <T extends HTMLElement>(delay: number) => {
  const [size, setSize] = useState<{ width?: number; height?: number }>({})

  const onResize = useMemo(() => debounce(setSize, delay, { leading: true }), [delay])

  const { ref } = useResizeObserver<T>({ onResize })

  return { ref, ...size }
}
